import styles from "./Hero.module.css";

import couchImage from "../../assets/image/Roadmap/couch.png";
import zackLede from "../../assets/home/zackLede.png";
import mobileZackLede from "../../assets/home/mobileZackLede.png";

import { FadeText } from "../Animation/FadeText";

import NextImage from "next/legacy/image";

import { Chip } from "../Chip/Chip";
import { Link } from "../Actions";
import NextLink from "next/link";

type HeroProps = {};
export const Hero: React.FC<HeroProps> = ({}) => {
  return (
    <>
      <div
        className={`p-4 pt-0 pb-0 flex relative overflow-hidden main-header tab:min-h-screen bg-coinage-orange text-coinage-orange${styles.heroContainer}`}>
        <div className="hidden tab:flex absolute overflow-hidden z-1 right-0 top-[0px] tab:bottom-auto lede-img-container h-screen w-screen">
          <NextImage src={zackLede} alt="zack" />
        </div>
        <div className="tab:hidden absolute overflow-hidden z-0 right-0 top-[0px] tab:bottom-auto  lede-img-container w-screen">
          <NextImage src={mobileZackLede} alt="zack" />
        </div>
        <div className="mx-auto max-w-[1200px] flex flex-col mt-[60px] mb-[15px] w-full z-1 relative pt-0 pb-0 tab:mb-[30px] tab:mt-[90px]">
          <FadeText
            textStyle="display1"
            className="text-coinage-orange mb-4 mt-[0] tab:mt-auto  ">
            OWN THE
            <br />
            NARRATIVE
            <br />
            IN CRYPTO.
          </FadeText>
          <p className={`body1 text-coinage-offWhite mb-auto`}>
            Own a piece of the first community-owned
            <br className="hidden tab:block" /> media outlet telling the story
            of crypto.
          </p>

          <NextLink className={styles.chipContainer} href="/about#mint">
            <Chip
              title="Join us"
              color="orange"
              link={{ text: "Get Your Membership Pass", to: "/about#mint" }}
              image={couchImage}
              videoSrc="/caucus/caucus600.mp4"
            />
            {/* <Chip
            color="teal"
            title="Register for a spot on our Caucus NFT access list."
            premintHero
            link={{ text: "Register with PREMINT", to: "/caucus/premint" }}
            image={couchImage}
            videoSrc="/camcorder-blue.mp4"
          /> */}
          </NextLink>
        </div>
      </div>
    </>
  );
};
